module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-SuperHeavyItalic.d5fdf4e.woff";